import { jsx as r, jsxs as l } from "react/jsx-runtime";
import { useId as h } from "react";
import { W as m } from "../index-D6IbTb4M.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import '../List.css';const w = "_list_k9wso_1", d = "_listItem_k9wso_10", z = "_listItemText_k9wso_16", W = "_iconWrapper_k9wso_20", f = "_check_k9wso_28", i = {
  list: w,
  listItem: d,
  listItemText: z,
  iconWrapper: W,
  check: f,
  "size--s": "_size--s_k9wso_32",
  "size--m": "_size--m_k9wso_44"
}, T = { s: "xsm", m: "sm" }, b = ({ classNames: t, direction: e, items: _, size: n = "m", ...p }) => {
  const c = h(), I = e ? { flexDirection: e } : {};
  return /* @__PURE__ */ r(
    "ul",
    {
      className: o(i.list, i[`size--${n}`], t == null ? void 0 : t.wrapper),
      "data-cxy-name": "list",
      style: I,
      ...p,
      children: _.map((k, x) => /* @__PURE__ */ l("li", { className: o(i.listItem, t == null ? void 0 : t.listItem), children: [
        /* @__PURE__ */ r("span", { className: o(i.iconWrapper, t == null ? void 0 : t.iconWrapper), children: /* @__PURE__ */ r(m, { className: o(i.check, t == null ? void 0 : t.checkIcon), color: "blue", size: T[n] }) }),
        /* @__PURE__ */ r("span", { className: o(i.listItemText, t == null ? void 0 : t.listItemText), children: k })
      ] }, `list-${c}-item-${x}`))
    }
  );
};
export {
  b as List
};
